import { useQuery } from "@tanstack/react-query";
import { health } from "@/api/client";
import type { Network } from "@/config/network";
import { defaultNetwork } from "@/config/network";

/**
 * Reads `/api/health` once on app mount + every time `version` bumps.
 * Falls back to the build-time default network if the fetch fails so
 * the UI stays usable when the backend is briefly unreachable.
 */
export function useHealth() {
  const query = useQuery({
    queryKey: ["health"],
    queryFn: ({ signal }) => health(signal),
    staleTime: 60_000, // network rarely changes mid-session
    retry: 1,
  });
  const network: Network = query.data?.network === "mainnet" ? "mainnet" : "testnet";
  // If the backend hasn't responded yet, ship the build-time guess so
  // the network chip + chain config render immediately.
  const effective: Network = query.data ? network : defaultNetwork();
  return { ...query, network: effective };
}
